import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy.svg",
  "use": "copy.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"copy.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 15h-1a1 1 0 100 2h1a3 3 0 003-3V5a3 3 0 00-3-3h-9a3 3 0 00-3 3v1a1 1 0 102 0V5a1 1 0 011-1h9a1 1 0 011 1v9a1 1 0 01-1 1zm-5-4a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1v-8zM5 8h8a3 3 0 013 3v8a3 3 0 01-3 3H5a3 3 0 01-3-3v-8a3 3 0 013-3z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol